/**
 * State DTO
 */
export class State {
  /**
   * @constructor
   */
  constructor(public id: number, public name?: string) {}
}
